@let jobValue = job();
@let isListTypeValue = isListType();

<rt-icon-button
  (click)="editDropdown.open = !editDropdown.open"
  [variant]="isListTypeValue ? 'outline' : 'plain'"
  [pressed]="editDropdown.open"
  rt-overlay-origin
  #editDropdownTrigger="rtOverlayOrigin"
  iconName="more-horiz"
  shape="square"
>
</rt-icon-button>
<ng-template
  (backdropClick)="editDropdown.open = false"
  [origin]="editDropdownTrigger"
  #editDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown [width]="DropdownWidth.SmallX">
    @if (jobValue.status === OfferStatus.Draft || jobValue.status === OfferStatus.Archived) {
      <rt-dropdown-item [routerLink]="['/offers', jobValue.slug, 'notes']">
        <rt-icon prefix name="pipeline-notes"></rt-icon>
        {{ 'app.offer_form_actions.go_to_notes' | translate }}
      </rt-dropdown-item>
      <rt-dropdown-item [routerLink]="['/offers', jobValue.slug, 'attachments']">
        <rt-icon prefix name="folder"></rt-icon>
        {{ 'app.offer_form_actions.go_to_files' | translate }}
      </rt-dropdown-item>
    }

    @if (jobValue.status === OfferStatus.Internal || jobValue.status === OfferStatus.Published) {
      <rt-dropdown-item [href]="jobValue.url!" hrefTarget="_blank" (click)="trackPreview.emit()">
        <rt-icon prefix name="open-in-new"></rt-icon>
        {{ 'app.offers.view' | translate }}
      </rt-dropdown-item>
    }
    @if (canManageJobs()) {
      <rt-dropdown-item (click)="action.emit(ActionType.Duplicate)">
        <rt-icon prefix name="content-copy"></rt-icon>
        {{ 'app.offers.duplicate' | translate }}
      </rt-dropdown-item>
      @if (jobValue.status !== OfferStatus.Archived) {
        <rt-dropdown-item (click)="action.emit(ActionType.Archive)">
          <rt-icon prefix name="archive"></rt-icon>
          {{ 'app.offers.archive' | translate }}
        </rt-dropdown-item>
      }
      @if (jobValue.status === OfferStatus.Archived) {
        <rt-dropdown-item (click)="action.emit(ActionType.Unarchive)">
          <rt-icon prefix name="unarchive"></rt-icon>
          {{ 'app.offers.unarchive' | translate }}
        </rt-dropdown-item>
      }
      @if (jobValue.status === OfferStatus.Archived || jobValue.status === OfferStatus.Draft) {
        <rt-dropdown-item (click)="action.emit(ActionType.Delete)">
          <rt-icon prefix name="delete"></rt-icon>
          {{ 'app.common.delete' | translate }}
        </rt-dropdown-item>
      }
    }
  </rt-dropdown>
</ng-template>
